import * as React from "react";
const IconTextFormatRemove = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M43 52.9H6.4c-1.2 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3H43c1.2 0 2.3-1 2.3-2.3s-1.1-2.3-2.3-2.3M59.3 41l2.3-2.3c.9-.9.9-2.3 0-3.2s-2.3-.9-3.2 0l-2.3 2.3-2.3-2.3c-.9-.9-2.3-.9-3.2 0s-.9 2.3 0 3.2l2.3 2.3-2.3 2.3c-.9.9-.9 2.3 0 3.2.4.4 1 .7 1.6.7s1.2-.2 1.6-.7l2.3-2.3 2.3 2.3c.4.4 1 .7 1.6.7s1.2-.2 1.6-.7c.9-.9.9-2.3 0-3.2zM30.5 10.1c-.3-.9-1-1.2-1.9-1.2h-7.7c-.8 0-1.7.3-1.9 1.2L4.2 45c-.6 1.4.3 2.8 1.8 2.8h5.1c.9 0 1.8-.7 2-1.3l2.4-6h18l2.2 6c.2.9 1.2 1.3 2 1.3h5.4c1.7-.2 2.7-1.7 2-2.9zM19.3 33.2l5.2-13.7 5.2 13.7z" />
  </svg>
);
export default IconTextFormatRemove;
